<template>
  <el-form-item :label="currentField.label" :label-width="currentField.labelWidth + 'px'">
    <el-date-picker
      v-model="currentField.componentValue"
      type="datetime"
      placeholder="Select date and time"
      v-on:change="dateTimePickerChange"
    ></el-date-picker>
  </el-form-item>
</template>

<script>
export default {
  name: 'DatetimePicker',
  props: ['currentField'],
  data() {
    return {
      // date: ''
    };
  },
  methods: {
    dateTimePickerChange(value) {
      this.currentField.componentValue = value;
    }
  }
};
</script>
